<template>
<div class="chapter">
<div class="inner_page">
<div class="part">
<div class="title-part"><a href="#/e9781429910613_toc01#toctitle2" id="title2"><span><strong class="b">BOOK I THE REALM OF FIRE</strong></span></a></div>
<br/><div class="blocktext"><div class="p-br-blocktext"><span>No, Time, thou shalt not boast that I do change: <br/>Thy pyramids built up with newer might <br/>To me are nothing novel, nothing strange; <br/>They are but dressings of a former sight.</span></div></div><br/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429910613_p01.vue?510329da